import React, { Component, Fragment } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
} from "reactstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import ButtonToggle from "../controls/_ButtonToggle";
import * as common from "../../lib/common"

export default class OrderApproveCfm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasChanged: false,
    }
  }
  sumClick = (tongTien) => {
    let orderInfor = this.props.orderInfor
    orderInfor['thanh_toan'] = tongTien
    this.setState({hasChanged: true})
    this.props.setOrderInfor(orderInfor)
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  valueChange = (e, name) => {
    let orderInfor = this.props.orderInfor
    switch (name) {
      case 'ngay_giao':
        orderInfor[name] = e
        break;
      case 'da_thanh_toan':
        orderInfor[name] = e
        break;
      case 'noi_xuat':
        orderInfor[name] = e.target.value
        break;
      case 'ghi_chu':
        orderInfor[name] = e.target.value
        break;
    }
    this.setState({hasChanged: true})
    this.props.setOrderInfor(orderInfor)
  }
  render() {
    const {
      requesting,
      orderInfor,
      errors,
      messages,
    } = this.props

    return (
      <div className="animated fadeIn">
        <Modal isOpen={this.props.isApprove} className="modal-md" modalClassName={"order-approve-cfm"}>
          <ModalHeader>Hoàn thành đơn hàng</ModalHeader>
          <ModalBody>
            <div className="col-sm-12  mb-1">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell">
                  <span className="input-group-text" htmlFor="noi_xuat">Nơi xuất</span>
                </div>
                <div className="display-table-cell">
                  <Input name="noi_xuat" type="textbox" name="ghi_chu" value={orderInfor.noi_xuat || ''} onChange={e => this.valueChange(e, "noi_xuat")} />
                </div>
              </div>
            </div>
            <div className="col-sm-12  mb-1">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell">
                  <span className="input-group-text" htmlFor="ngay_giao">Ngày giao</span>
                </div>
                <DatePicker id="ngay_giao" name="ngay_giao" 
                  dateFormat="DD/MM/YYYY" 
                  selected={common.parseDatetime(orderInfor.ngay_giao)} 
                  onChange={e => this.valueChange(e, "ngay_giao")} 
                  minDate={common.currentDate()}
                  required 
                  autoComplete={"off"}
                  className={"form-control display-table-cell"} />
              </div>
            </div>
            <div className="col-sm-12  mb-1">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell" htmlFor="da_thanh_toan">
                  <span className="input-group-text">Đã thanh toán</span>
                </div>
                <div className="mb-12 display-table-cell">
                  <ButtonToggle name="da_thanh_toan" handleChange={e => this.valueChange(e, "da_thanh_toan")} isChecked={orderInfor.da_thanh_toan} />
                </div>
              </div>
            </div>
            <div className="col-sm-12  mb-1">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell">
                  <span className="input-group-text" htmlFor="tong_tien">Tiền trên đơn</span>
                </div>
                <div className="display-table-cell">
                  <label className="form-control">{orderInfor.tong_tien ? orderInfor.tong_tien.toLocaleString() : 0}</label>
                </div>
              </div>
            </div>
            <div className="col-sm-12  mb-1">
              <Input type="textarea" maxLength={250} name="ghi_chu" placeholder="Ghi chú" value={orderInfor.ghi_chu || ''} onChange={e => this.valueChange(e, "ghi_chu")} />
              <div className="clearfix"></div>
            </div>
            <div className="col-sm-12">
              {!requesting && !!errors.length && (
                <Errors message="Failure to signup due to:" errors={errors} />
              )}
              {!requesting && !!messages.length && (
                <Messages messages={messages} />
              )}
            </div>
            <div className="col-sm-12">
              <div className="btn-group float-right" role="group">
                <Button disabled={requesting} className="btn btn-success mr-1" onClick={() => this.props.approveOrderClick(orderInfor)}>
                  <i className="fa fa-check"></i><span className="d-none d-sm-inline">&nbsp;Hoàn thành</span></Button>
                <Button className="btn btn-danger" onClick={() => this.props.onClose()}>
                  <i className="fa fa-close"></i><span className="d-none d-sm-inline">&nbsp;Đóng</span></Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Order/_OrderApproveCfm.js